import { EmailUnsubscribe as EmailUnsubscribeComponent } from 'components/EmailUnsubscribe';
import { FunctionComponent } from 'react';
import { RouteComponentProps } from 'react-router-dom';

interface MatchParams {
    token?: string;
}

type EmailUnsubscribeProps = RouteComponentProps<MatchParams>;

/**
 * Public route target for the unsubscribe flow — recipients of a campaign
 * email land here when they click the footer link. No auth: the signed token
 * in the URL is the sole identifier.
 */
const EmailUnsubscribe: FunctionComponent<EmailUnsubscribeProps> = props => {
    return <EmailUnsubscribeComponent token={props.match.params.token || ''} />;
};

export default EmailUnsubscribe;
